import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmartLogTailComponent } from './components/smart-log-tail/smart-log-tail.component';
import { ErrorFixability } from './components/error-fixability/error-fixability.component';
import { APIErrorAlertComponent } from './components/api-error-alert/api-error-alert.component';
import { APIErrorAlertFromContextComponent } from './components/api-error-alert-from-context/api-error-alert-from-context.component';
import { DkuFrontendCoreModule } from 'dku-frontend-core';

@NgModule({
    imports: [
        CommonModule,
        DkuFrontendCoreModule
    ],
    declarations: [
        ErrorFixability,
        SmartLogTailComponent,
        APIErrorAlertComponent,
        APIErrorAlertFromContextComponent
    ],
    exports: [
        ErrorFixability,
        SmartLogTailComponent,
        APIErrorAlertComponent,
        APIErrorAlertFromContextComponent
    ]
})
export class DataikuAPIModule { }
